import { getAreaBudgetNavConfig } from './areaBudgetNavConfig';

export const AREA_BUDGET_NAV_REQUEST = 'archon:area-budget-nav-request';

/** @deprecated Use requestAreaBudgetNavigation('survey', detail) */
export const SURVEY_BUDGET_NAV_REQUEST = AREA_BUDGET_NAV_REQUEST;

/**
 * When the area budget module is mounted it listens and applies unsaved-change guards.
 * Returns true if the event was dispatched (caller should not navigate directly).
 */
export function requestAreaBudgetNavigation(area, detail) {
  const config = getAreaBudgetNavConfig(area);
  if (!config || typeof window === 'undefined' || !config.isBudgetPage(window.location.pathname)) {
    return false;
  }
  window.dispatchEvent(new CustomEvent(AREA_BUDGET_NAV_REQUEST, {
    detail: { area, ...detail },
  }));
  return true;
}

/** Back-compat wrapper for Survey flyout */
export function requestSurveyBudgetNavigation(detail) {
  return requestAreaBudgetNavigation('survey', detail);
}
